import type { CompanyLogoSubparentType } from "enums/CompanyLogoSubparentType";

interface LogoAttachment {
  id: string;
  subParentId?: string | null;
  assetUrl?: string | null;
}

/** Every logo of a kind, oldest first, as the attachments list arrives. */
export const logosOfKind = <T extends LogoAttachment>(
  attachments: readonly T[],
  kind: CompanyLogoSubparentType,
): T[] => attachments.filter((attachment) => attachment.subParentId === kind);

/** The logo shown and served for a kind: the newest, as the server's `getCompanyLogos` picks. */
export const currentLogoOfKind = <T extends LogoAttachment>(
  attachments: readonly T[],
  kind: CompanyLogoSubparentType,
): T | undefined => logosOfKind(attachments, kind).pop();
